// LoadingContext.js
import React, { createContext, useContext, useState } from "react";
import { Spin } from "antd";

// Create context
const LoadingContext = createContext();

// Spinner provider component
export const LoadingProvider = ({ children }) => {
  const [spinning, setSpinning] = useState(false);
  const [percent, setPercent] = useState(0);

  // Show the spinner and start the progress
  const showSpinner = () => {
    setSpinning(true);
    let ptg = -10;
    const interval = setInterval(() => {
      ptg += 5;
      setPercent(ptg);
      if (ptg >= 100) {
        clearInterval(interval);
      }
    }, 100);
  };

  // Hide the spinner
  const hideSpinner = () => {
    setSpinning(false);
    setPercent(0);
  };

  // Context value
  const contextValue = {
    showSpinner,
    hideSpinner,
    setSpinnerPercent: setPercent,
  };

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
      <Spin spinning={spinning} percent="auto" fullscreen size="large" />
    </LoadingContext.Provider>
  );
};

// Custom hook to use spinner anywhere
export const useSpinner = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useSpinner must be used within a LoadingProvider");
  }
  return context;
};
